<!-- "意见反馈" 表单弹窗 -->
<template>
  <el-dialog
    title=""
    width="35%"
    append-to-body
    :visible.sync="isShow"
    :before-close="beforeClose"
    :v-modal="false"
    :close-on-click-modal="false"
    @closed="dialogClosed"
  >
    <div class="vis-big-title fw-700 fs-18">意见反馈</div>
    <div class="mt20">
      <el-form
        ref="offerForm"
        :model="offerForm"
        :rules="offerRules"
        auto-complete="on"
        label-position="left"
      >
        <el-form-item prop="title">
          <el-input
            v-model="offerForm.title"
            placeholder="请输入标题"
            type="text"
            tabindex="1"
            auto-complete="on"
          >
          </el-input>
        </el-form-item>

        <el-form-item prop="content">
          <el-input
            v-model="offerForm.content"
            placeholder="请输入反馈意见"
            type="textarea"
            tabindex="1"
            auto-complete="on"
          >
          </el-input>
        </el-form-item>

        <el-form-item prop="name">
          <el-input
            v-model="offerForm.name"
            placeholder="请输入联系人"
            type="text"
            tabindex="1"
            auto-complete="on"
          >
          </el-input>
        </el-form-item>

        <el-form-item prop="phonenumber">
          <el-input
            v-model="offerForm.phonenumber"
            placeholder="请输入您的手机号"
            type="text"
            tabindex="1"
            auto-complete="on"
          >
          </el-input>
        </el-form-item>

        <el-form-item prop="link">
          <el-input
            v-model="offerForm.link"
            placeholder="选填项，如有相关链接，请复制粘贴到这里"
            type="text"
            tabindex="1"
            auto-complete="on"
          >
          </el-input>
        </el-form-item>

        <el-button
          type="primary"
          style="width: 100%"
          :loading="loading"
          @click="offerSubmit"
          >确认提交</el-button
        >
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import { formValidMobile } from "@/utils/validate";

export default {
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      offerForm: {},
      offerRules: {
        title: [{ required: true, trigger: "change", message: "请输入标题" }],
        name: [{ required: true, trigger: "change", message: "请输入联系人" }],
        content: [
          { required: true, trigger: "change", message: "请输入反馈意见" },
        ],
        phonenumber: [
          { required: true, trigger: "blur", message: "请输入手机号" },
          {
            validator: formValidMobile,
            trigger: "blur",
            message: "手机号格式错误",
          },
        ],
      },
    };
  },
  methods: {
    beforeClose() {
      this.$emit("close", false);
    },
    dialogClosed() {
      this.$refs.offerForm.resetFields();
    },
    async offerSubmit() {
      this.$refs.offerForm.validate(async (valid) => {
        if (valid) {
          this.loading = true;
          const res = await this.$api.postIdeaApi(this.offerForm);
          if (res.code === 200) {
            this.$message.success("提交成功");
            setTimeout(() => {
              this.beforeClose();
              this.loading = false;
            }, 2000);
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
